import { VideoObject } from 'src/modules/shared/Types'

const homeApiResponseParser = {
  readVideosResponse: (data): Array<VideoObject> => {
    const videos: Array<VideoObject> = data.map((x) => {
      return {
        id: x._id,
        src: { src: x.content.url, type: 'video/mp4' },
        thumbnailUrl: x.thumbnailUrl,
        title: x.title,
      }
    })

    return videos
  },
}

export default homeApiResponseParser
